export const INVESMENT_TYPES= {
    product: "product",
    toshin: "toshin",
    kabu: "kabu"
}